angular.module('rjmNg.common.api').factory 'ImportTokens', [
  "$resource"
  "phpServiceUrl"
  (
    $resource
    phpServiceUrl
  ) ->

    (clientId) ->
      defaultParams =
        withCredentials: true
        headers:
          Accept: 'application/json'
          'Content-Type': 'application/json'

      actions =
        create: angular.extend {}, defaultParams,
          method: 'POST'

      importTokens = $resource phpServiceUrl("/client/#{clientId}/importtoken"), {}, actions

      create: () ->
        data =
          owner_id: clientId

        importTokens.create(data).$promise

]
